import { render, staticRenderFns } from "./Appmenu.vue?vue&type=template&id=16b10f58&scoped=true&"
import script from "./Appmenu.vue?vue&type=script&lang=js&"
export * from "./Appmenu.vue?vue&type=script&lang=js&"
import style0 from "./Appmenu.vue?vue&type=style&index=0&id=16b10f58&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b10f58",
  null
  
)

export default component.exports